module.exports = __webpack_public_path__ + "static/media/2research.ae708bbe.jpg";